import { createSelector } from "@reduxjs/toolkit";

const newsSelector = (state) => {
  return state["news"];
};

export const listNewsSelector = createSelector(
  [newsSelector],
  (newsState) => newsState.listNews
);

export const newDetailSelector = createSelector(
  [newsSelector],
  (newsState) => newsState.newDetail
);
